import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly specialist?: { readonly __typename?: 'AccountsSpecialist', readonly id: string, readonly name: string, readonly email?: string | null, readonly notifications: ReadonlyArray<{ readonly __typename?: 'AccountsNotification', readonly id: string }> } | null } | null };

export type GetCurrentUserListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserListQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly parentUser?: { readonly __typename?: 'AccountsParentUser', readonly id: string } | null, readonly specialists: ReadonlyArray<{ readonly __typename?: 'AccountsSpecialist', readonly id: string, readonly name: string }> } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($id: ID) {
  currentUser {
    specialist(id: $id) {
      id
      name
      email
      notifications {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCurrentUserListDocument = gql`
    query GetCurrentUserList {
  currentUser {
    parentUser {
      id
    }
    specialists {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentUserListQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserListQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
      }
export function useGetCurrentUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
        }
export function useGetCurrentUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>(GetCurrentUserListDocument, options);
        }
export type GetCurrentUserListQueryHookResult = ReturnType<typeof useGetCurrentUserListQuery>;
export type GetCurrentUserListLazyQueryHookResult = ReturnType<typeof useGetCurrentUserListLazyQuery>;
export type GetCurrentUserListSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserListSuspenseQuery>;
export type GetCurrentUserListQueryResult = Apollo.QueryResult<GetCurrentUserListQueryPage, GetCurrentUserListQueryVariables>;